import { deleteDocument } from "../../documents/services/documents.service";
import { EyeIcon, PlusIcon, TrashIcon } from "../../shared/Icons";
import { themeAtom } from "../../shared/atoms";
import { openPdfInNewTab } from "../../shared/services/utils";
import { Certificate } from "../models/certificates.interfaces";
import UploadButton from "./UploadButton";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

type AppendicesExpandedProps = {
  document: Certificate;
  appendices: Certificate[];
  searchDocs: () => void;
};

export function AppendicesExpanded({ document, appendices, searchDocs }: AppendicesExpandedProps) {
  const theme = useAtomValue(themeAtom);
  return (
    <tr
      className={twMerge(
        "border-b border-l-2 border-l-green",
        theme.headerComponent.notifications.headerBorder,
        theme.home.tailwind.textDefault,
      )}
    >
      <td className="p-4" colSpan={8}>
        <div className="flex flex-row">
          <div className="pt-[12px] text-sm">Appendix</div>
          <div className="flex flex-wrap pl-8">
            {!appendices?.length && <div className="p-[12px] text-sm">No appendices uploaded</div>}

            {
              // Appendix
              appendices.map((appendix) => (
                <div
                  className={twMerge(
                    "group mb-3 mr-2 flex w-[250px] flex-row items-center justify-between rounded-[8px] border px-[12px] py-[10px] text-xs",
                    theme.myVesselsTable.tailwind.tableBorder,
                    theme.home.tailwind.textDefault,
                  )}
                >
                  <div
                    className="cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap"
                    onClick={() => openPdfInNewTab(appendix)}
                  >
                    {appendix.fileName}
                  </div>
                  <div className="mt-[2px] flex flex-row">
                    <EyeIcon
                      className="ml-3 size-4 cursor-pointer opacity-0 group-hover:opacity-100"
                      color={theme.crtDropInput.green}
                      onClick={() => openPdfInNewTab(appendix)}
                    />
                    <TrashIcon
                      className="ml-3 size-4 cursor-pointer opacity-0 group-hover:opacity-100"
                      color={theme.certDocumentIcon.trash}
                      onClick={() => {
                        deleteDocument(appendix.s3Path ?? "");
                        searchDocs();
                      }}
                    />
                  </div>
                </div>
              ))
            }

            {/* Add Appendix */}
            <UploadButton
              parentDoc={document}
              searchDocs={searchDocs}
              inner={
                <div className="flex cursor-pointer flex-row py-3">
                  <PlusIcon
                    className={twMerge(
                      "border-1 text-red ml-4 h-5 w-5 rounded-full border",
                      theme.crtDropInput.borderGreen,
                      theme.home.tailwind.spinner,
                    )}
                  />
                  <div className="pl-[8px] pt-[1px] text-sm text-green">Add appendix</div>
                </div>
              }
            />
          </div>
        </div>
      </td>
    </tr>
  );
}
